export default __webpack_public_path__ + "static/media/cakeBanner.a1370ae0.jpg";